// extracted by mini-css-extract-plugin
export var standaloneTable = "_ep-0";
export var standaloneTableWithBodyFill = "_ep-1";
export var withExtraHeader = "_ep-2";